/* Only the motion preference policy is custom; Dawn owns all slider interactions. */
if (!customElements.get('wr-hero-motion')) {
  customElements.define('wr-hero-motion', class extends HTMLElement {
    async connectedCallback() {
      await customElements.whenDefined('slideshow-component');
      if (!this.isConnected) return;
      this.slideshow = this.querySelector('slideshow-component');
      customElements.upgrade(this.slideshow);
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        if (!this.motion.matches || !this.slideshow.sliderAutoplayButton) return;
        this.slideshow.pause();
        this.slideshow.autoplayButtonIsSetToPlay = false;
        this.slideshow.togglePlayButtonState(true);
      };
      this.motion.addEventListener('change', this.onMotionChange);
      this.onMotionChange();
    }

    disconnectedCallback() {
      this.motion?.removeEventListener('change', this.onMotionChange);
      if (this.slideshow?.slider) this.slideshow.pause();
    }
  });
}
